import SVGCircle from "./SVGCircle";
import SVGFactory from "./SVGFactory";

export default class ProgressBar {
  
  private readonly circle: SVGCircle;
  private length: number;
  private progress: number;
  private requestNextFrame: boolean;
  

  constructor(element: HTMLElement, length: number) {
    this.length = length;
    this.requestNextFrame = false;
    this.progress = 0;

    const svg = SVGFactory.create("svg", {
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid slice",
      transform: "rotate(-90)",
    });

    this.circle =  new SVGCircle();
    svg.appendChild(this.circle.htmlElement);
    element.appendChild(svg);
  }

  public updateProgress(progress: number): void {
    this.progress = Math.min(this.progress + progress, this.length);

    if (!this.requestNextFrame) {
      this.requestNextFrame = true;
      requestAnimationFrame(() => this.animateStroke());
    }
  }
      
  private animateStroke(): void {
    this.circle.stroke(this.progress / this.length);
    this.requestNextFrame = false;
  }
}